import React, { useEffect, useState }from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars} from '@fortawesome/free-solid-svg-icons';

export default function Header() {
  useEffect(() => {
    const handleScroll = () => {
    if (window.scrollY > 20) {
      document.querySelector(".header").className = "header scroll"
      } else {
      document.querySelector(".header").className = "header";
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  
    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);  

  return (
   <header className="header">
     <nav className="navbar navbar-expand-lg navbar-expand-md">
       <div className="container">
        <a className="navbar-brand" href="javascript:void()" title="Muhammad Ramzan Nawab">MRN</a>
        <button className="menu navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded={!isNavCollapsed ? true : false} aria-label="Toggle navigation" onClick={handleNavCollapse}>
          <FontAwesomeIcon icon={faBars} />
        </button>
        <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse justify-content-end `} id="navbar">
        <ul className="nav navbar-nav">
          <li className="nav-item"><a className="nav-link" href="#home">Home</a></li>
          <li className="nav-item"><a className="nav-link" href="#about">About</a></li>
          <li className="nav-item"><a className="nav-link" href="#skill">Skills</a></li>
          <li className="nav-item"><a className="nav-link" href="#project">Projects</a></li>
          <li className="nav-item"><a className="nav-link" href="#contact">Contact</a></li>
        </ul> 
        </div>

       
       </div> 
     </nav>
   </header>
  )
}
